// Importy modułów Swiper
const { Navigation, Pagination, Autoplay } = window;

// Rejestracja modułów globalnie dla Swiper (tylko te dostępne)
if (window.Swiper) {
    const mods = [];
    if (window.SwiperNavigation) mods.push(window.SwiperNavigation);
    if (window.SwiperPagination) mods.push(window.SwiperPagination);
    if (window.SwiperAutoplay) mods.push(window.SwiperAutoplay);
    if (window.SwiperEffectFade) mods.push(window.SwiperEffectFade);
    if (mods.length) window.Swiper.use(mods);
}



// var swiper = new Swiper(".specjalizacjeSwiper", {
//   grabCursor: false,
//   simulateTouch: false,
//   slidesPerView: 3,
//   spaceBetween: 16,
//   loop: true,
//   navigation: {
//       nextEl: ".specjalizacjeSwiper-next",
//       prevEl: ".specjalizacjeSwiper-prev",
//     },
// });

function syncHomepageSliderHeight(swiperInstance) {
    if (!swiperInstance || !swiperInstance.slides || !swiperInstance.slides.length) {
        return;
    }

    let maxHeight = 0;

    swiperInstance.slides.forEach((slide) => {
        slide.style.height = 'auto';
        maxHeight = Math.max(maxHeight, slide.offsetHeight);
    });

    if (!maxHeight) {
        return;
    }

    swiperInstance.el.style.height = `${maxHeight}px`;

    swiperInstance.slides.forEach((slide) => {
        slide.style.height = `${maxHeight}px`;
    });

    swiperInstance.update();
}

function syncSpecsSliderViewport(sliderElement) {
    if (!sliderElement) {
        return;
    }

    const sliderRect = sliderElement.getBoundingClientRect();
    const viewportBleedLeft = Math.max(sliderRect.left, 0);
    const viewportBleedRight = Math.max(window.innerWidth - sliderRect.right, 0);

    sliderElement.style.setProperty('--viewport-bleed-left', `${viewportBleedLeft}px`);
    sliderElement.style.setProperty('--viewport-bleed-right', `${viewportBleedRight}px`);
}

document.addEventListener('DOMContentLoaded', function() {
    const homepageSlider = document.querySelector('.js-homepage-swiper');
    const specsSlider = document.querySelector('.js-specs-swiper');
    const partnersSlider = document.querySelector('.js-partners-swiper');
    const jobsSlider = document.querySelector('.js-jobs-swiper');

    document.addEventListener('click', function(event) {
        const trigger = event.target.closest('[data-mydr-modal-open]');

        if (!trigger) {
            return;
        }

        const targetId = trigger.getAttribute('data-mydr-modal-open');
        const mydrTrigger = targetId ? document.getElementById(targetId) : null;

        if (!mydrTrigger) {
            return;
        }

        event.preventDefault();
        mydrTrigger.click();
    });

    if (!window.Swiper) {
        return;
    }

    if (homepageSlider) {
        const homepageSection = homepageSlider.closest('.homepage-slider.slider');
        const homepageSlides = homepageSlider.querySelectorAll('.swiper-slide');

        const homepageSwiper = new window.Swiper(homepageSlider, {
            grabCursor: true,
            watchOverflow: true,
            slidesPerView: 1,
            spaceBetween: 0,
            speed: 700,
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
            loop: homepageSlides.length > 1,
            autoplay: homepageSlides.length > 1 ? {
                delay: 5000,
                disableOnInteraction: false,
            } : false,
            pagination: homepageSection ? {
                el: homepageSection.querySelector('.slider__pagination'),
                clickable: true,
            } : undefined,
            on: {
                init(swiper) {
                    syncHomepageSliderHeight(swiper);
                },
                resize(swiper) {
                    syncHomepageSliderHeight(swiper);
                },
            },
        });

        window.addEventListener('load', function() {
            syncHomepageSliderHeight(homepageSwiper);
        }, { once: true });
    }

    if (specsSlider) {
        const specsSwiper = new window.Swiper(specsSlider, {
            allowTouchMove: false,
            grabCursor: false,
            loop: true,
            watchOverflow: true,
            speed: 5000,
            autoplay: {
                delay: 0,
                disableOnInteraction: false,
            },
            slidesPerView: 1.2,
            spaceBetween: 16,
            breakpoints: {
                768: {
                    slidesPerView: 2.2,
                    spaceBetween: 20,
                },
                1200: {
                    slidesPerView: 3.7,
                    spaceBetween: 24,
                },
            },
        });

        let pausedSpecsTransition;
        let resumeSpecsTransition;
        let specsCarouselPaused = false;
        let touchStartPoint;
        let activeSpecsTransition;

        if (!specsSlider.hasAttribute('tabindex')) {
            specsSlider.setAttribute('tabindex', '0');
        }

        specsSlider.setAttribute('aria-label', 'Karuzela specjalizacji');

        const clearSpecsTransition = () => {
            if (resumeSpecsTransition) {
                specsSwiper.off('transitionEnd', resumeSpecsTransition);
                resumeSpecsTransition = undefined;
            }

            if (specsSwiper.onSlideToWrapperTransitionEnd) {
                specsSwiper.wrapperEl.removeEventListener('transitionend', specsSwiper.onSlideToWrapperTransitionEnd);
                delete specsSwiper.onSlideToWrapperTransitionEnd;
            }

            if (specsSwiper.onTranslateToWrapperTransitionEnd) {
                specsSwiper.wrapperEl.removeEventListener('transitionend', specsSwiper.onTranslateToWrapperTransitionEnd);
                delete specsSwiper.onTranslateToWrapperTransitionEnd;
            }

            specsSwiper.animating = false;
        };

        const pauseSpecsCarousel = () => {
            if (specsCarouselPaused) {
                return;
            }

            const currentTranslate = specsSwiper.getTranslate();
            const targetTranslate = specsSwiper.rtlTranslate ? -specsSwiper.translate : specsSwiper.translate;
            const previousTranslate = specsSwiper.rtlTranslate ? -specsSwiper.previousTranslate : specsSwiper.previousTranslate;
            const transitionStart = activeSpecsTransition ? activeSpecsTransition.startTranslate : previousTranslate;
            const transitionDuration = activeSpecsTransition ? activeSpecsTransition.duration : specsSwiper.params.speed;
            const totalDistance = Math.abs(targetTranslate - transitionStart);
            const remainingDistance = Math.abs(targetTranslate - currentTranslate);

            pausedSpecsTransition = {
                targetTranslate,
                duration: totalDistance ? (transitionDuration * remainingDistance) / totalDistance : 0,
            };
            activeSpecsTransition = undefined;

            clearSpecsTransition();
            specsSwiper.setTransition(0);
            specsSwiper.setTranslate(currentTranslate);
            specsSwiper.updateActiveIndex();
            specsSwiper.updateSlidesClasses();
            specsSwiper.autoplay.stop();
            specsCarouselPaused = true;
        };

        const resumeSpecsCarousel = () => {
            if (!specsCarouselPaused) {
                return;
            }

            if (!pausedSpecsTransition) {
                specsCarouselPaused = false;
                specsSwiper.autoplay.start();
                return;
            }

            const { targetTranslate, duration } = pausedSpecsTransition;
            specsCarouselPaused = false;
            activeSpecsTransition = {
                startTranslate: specsSwiper.getTranslate(),
                targetTranslate,
                duration,
            };

            resumeSpecsTransition = () => {
                specsSwiper.updateActiveIndex();
                specsSwiper.updateSlidesClasses();
                pausedSpecsTransition = undefined;
                resumeSpecsTransition = undefined;
                activeSpecsTransition = undefined;
                specsSwiper.autoplay.start();
            };
            specsSwiper.once('transitionEnd', resumeSpecsTransition);
            specsSwiper.translateTo(targetTranslate, duration, true, false);
        };

        const moveSpecsSlide = (direction) => {
            pauseSpecsCarousel();
            pausedSpecsTransition = undefined;
            activeSpecsTransition = undefined;
            clearSpecsTransition();

            if (direction === 'next') {
                specsSwiper.slideNext(500);
                return;
            }

            specsSwiper.slidePrev(500);
        };

        const previousSpecsButton = specsSlider.querySelector('.specs__slider-prev');
        const nextSpecsButton = specsSlider.querySelector('.specs__slider-next');

        previousSpecsButton?.addEventListener('click', () => {
            moveSpecsSlide('prev');
        });

        nextSpecsButton?.addEventListener('click', () => {
            moveSpecsSlide('next');
        });

        specsSlider.addEventListener('pointerenter', (event) => {
            if (event.pointerType === 'mouse') {
                pauseSpecsCarousel();
            }
        });

        specsSlider.addEventListener('pointerleave', (event) => {
            if (event.pointerType === 'mouse') {
                resumeSpecsCarousel();
            }
        });

        specsSlider.addEventListener('focusin', () => {
            pauseSpecsCarousel();
        });

        specsSlider.addEventListener('focusout', (event) => {
            if (!specsSlider.contains(event.relatedTarget)) {
                resumeSpecsCarousel();
            }
        });

        specsSlider.addEventListener('keydown', (event) => {
            if (event.key === 'ArrowRight') {
                event.preventDefault();
                moveSpecsSlide('next');
            }

            if (event.key === 'ArrowLeft') {
                event.preventDefault();
                moveSpecsSlide('prev');
            }
        });

        specsSlider.addEventListener('pointerdown', (event) => {
            if (event.pointerType !== 'touch') {
                return;
            }

            touchStartPoint = { x: event.clientX, y: event.clientY };
        });

        specsSlider.addEventListener('pointerup', (event) => {
            if (event.pointerType !== 'touch' || !touchStartPoint || event.target.closest('a')) {
                touchStartPoint = undefined;
                return;
            }

            const distance = Math.hypot(event.clientX - touchStartPoint.x, event.clientY - touchStartPoint.y);
            touchStartPoint = undefined;

            if (distance > 10) {
                return;
            }

            if (specsCarouselPaused) {
                resumeSpecsCarousel();
            } else {
                pauseSpecsCarousel();
            }
        });

        let specsResizeFrame = null;

        window.addEventListener('resize', () => {
            if (specsResizeFrame) {
                window.cancelAnimationFrame(specsResizeFrame);
            }

            specsResizeFrame = window.requestAnimationFrame(() => {
                syncSpecsSliderViewport(specsSlider);
                specsResizeFrame = null;
            });
        });

        window.addEventListener('load', () => {
            syncSpecsSliderViewport(specsSlider);
        }, { once: true });
    }

    if (partnersSlider) {
        new window.Swiper(partnersSlider, {
            allowTouchMove: false,
            watchOverflow: true,
            loop: true,
            speed: 6000,
            autoplay: {
                delay: 0,
                disableOnInteraction: false,
            },
            slidesPerView: 2,
            spaceBetween: 20,
            breakpoints: {
                768: {
                    slidesPerView: 3.5,
                    spaceBetween: 28,
                },
                1200: {
                    slidesPerView: 5,
                    spaceBetween: 36,
                },
            },
        });
    }

    if (jobsSlider) {
        const jobsSection = jobsSlider.closest('.page-jobs.list');
        const jobsSlides = jobsSlider.querySelectorAll('.swiper-slide');

        if (!jobsSection) {
            return;
        }

        const jobsStaticDesktopQuery = window.matchMedia('(min-width: 1200px)');
        let jobsSwiper;

        const initJobsSwiper = () => new window.Swiper(jobsSlider, {
            grabCursor: true,
            watchOverflow: true,
            slidesPerView: 1.2,
            spaceBetween: 16,
            navigation: {
                nextEl: jobsSection.querySelector('.jobs__slider-next'),
                prevEl: jobsSection.querySelector('.jobs__slider-prev'),
            },
            pagination: {
                el: jobsSection.querySelector('.jobs__slider-pagination'),
                clickable: true,
            },
            breakpoints: {
                768: {
                    slidesPerView: 2.2,
                    spaceBetween: 20,
                },
                1200: {
                    slidesPerView: 3.7,
                    spaceBetween: 24,
                },
            },
        });

        const syncJobsSlider = () => {
            const shouldDisableSlider = jobsSection.classList.contains('list--static-desktop')
                && jobsSlides.length <= 4
                && jobsStaticDesktopQuery.matches;

            jobsSection.classList.toggle('list--static-active', shouldDisableSlider);

            if (shouldDisableSlider) {
                if (jobsSwiper) {
                    jobsSwiper.destroy(true, true);
                    jobsSwiper = undefined;
                }

                return;
            }

            if (!jobsSwiper) {
                jobsSwiper = initJobsSwiper();
            }
        };

        syncJobsSlider();
        jobsStaticDesktopQuery.addEventListener('change', syncJobsSlider);
    }
});


// $(function() {
//   $('.twentytwenty-init').twentytwenty({
//     orientation: 'vertical',
//     move_with_handle_only: true,
//   });
// })

